import { render } from "./AiColorSwatches.vue?vue&type=template&id=f9bba520&scoped=true"
import script from "./AiColorSwatches.vue?vue&type=script&lang=js"
export * from "./AiColorSwatches.vue?vue&type=script&lang=js"

import "./AiColorSwatches.vue?vue&type=style&index=0&id=f9bba520&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bba520"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiColorSwatches.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9bba520"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9bba520', __exports__)) {
    api.reload('f9bba520', __exports__)
  }
  
  module.hot.accept("./AiColorSwatches.vue?vue&type=template&id=f9bba520&scoped=true", () => {
    api.rerender('f9bba520', render)
  })

}


export default __exports__